import { patternmixConstants } from '../constant/patternmix'


export default function patternmix(state = {}, action) {
  switch (action.type) {

    case patternmixConstants.READ_PATTERNMIXES_SUCCESS:
      return { ...state, totalCount: action.resp.totalCount }

    // case patternmixConstants.READ_PATTERNMIXES_SUCCESS:
    //   return { ...state, readAll: action.resp, isReady: true }

    // case patternmixConstants.READ_PATTERNMIXES_FAILURE:
    //   return { ...state, isReady: true }

    default:
      return state
  }
}